var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    strokeWidth: 1.2,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12C10.2426 12 11.25 10.9926 11.25 9.75C11.25 8.50736 10.2426 7.5 9 7.5C7.75736 7.5 6.75 8.50736 6.75 9.75C6.75 10.9926 7.75736 12 9 12Z",
    stroke: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.0227C1.5 7.72455 1.5 6.57541 2.06176 5.74995C2.30496 5.39261 2.61746 5.08578 2.98143 4.84701C3.52166 4.4926 4.198 4.36592 5.2335 4.32064C5.72764 4.32064 6.15309 3.95301 6.25 3.47727C6.39536 2.76367 7.03354 2.25 7.77472 2.25H10.2253C10.9664 2.25 11.6046 2.76367 11.75 3.47727C11.8469 3.95301 12.2723 4.32064 12.7665 4.32064C13.802 4.36592 14.4783 4.4926 15.0186 4.84701C15.3825 5.08578 15.695 5.39261 15.9382 5.74995C16.5 6.57541 16.5 7.72455 16.5 10.0227C16.5 12.3209 16.5 13.4701 15.9382 14.2955C15.695 14.6528 15.3825 14.9597 15.0186 15.1985C14.1778 15.75 13.0075 15.75 10.6666 15.75H7.33333C4.99256 15.75 3.82218 15.75 2.98143 15.1985C2.61746 14.9597 2.30496 14.6528 2.06176 14.2955C1.9031 14.0623 1.78924 13.8034 1.70755 13.5",
    stroke: "#000",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.5H13.5",
    stroke: "#000",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon2);
export default __webpack_public_path__ + "static/media/camera-icon2.961d829b13a62c4ca96e3db9ebe7e2c2.svg";
export { ForwardRef as ReactComponent };